/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Cropper from 'material/imageupload/components/cropper/cropper_container';
import Controls from 'material/imageupload/components/controls/controls';
import Input from 'material/imageupload/components/input/input_container';
import Gif from 'material/imageupload/components/gif/gif';
// styles
import injectSheet from 'react-jss';
import styles from 'material/imageupload/imageupload_styles';



/* ========== ~~~~~~~~~~ IMAGE UPLOAD ~~~~~~~~~~ ========== */
class ImageUpload extends Component {
	constructor(props) {
		super(props);
		this.state = {
			canvas: null,
			image: null,
			imageSrc: null,
			zoom: 3,
			file: null,
			isGif:false,
			controlsOpen: false
		};
	};
	componentDidUpdate(prevProps){
		if(prevProps.uploadingCustomImage !== this.props.uploadingCustomImage){
			 if(!this.props.uploadingCustomImage) this.setState({controlsOpen: false, imageSrc: null, image: null, zoom: 3})
		}
	}
	//creates blob and image url for uploaded images
	getCroppedImg = (fileName, preview, fileType) => {
		const canvas = this.state.canvas;
		if(!this.state.isGif){
            new Promise((resolve, reject) => {
                canvas.toBlob(file => {
                    file.name = fileName;
                    resolve(file);
                }, fileType);
            }).then(blob => {
                if (preview) {
                    this.setState({ blob: blob });
                    this.props.previewImage(URL.createObjectURL(blob));
                } else {
                    this.props.processImage(blob);
                }
            });
		}else{
            fetch(this.state.imageSrc)
                .then(res => res.blob())
                .then(blob => {
                    if (preview) {
                        this.setState({ blob: blob });
                        this.props.previewImage(URL.createObjectURL(blob));
                    } else {
                        this.props.processImage(blob);
                        this.setState({ imageSrc: null, image: null });
                    }
				})
		}

	};
	onSelectFile = e => {
        const file = e.target.files[0];
        //will be replaced with alert action
        if(file.size/1024/1024 > 5){
            this.props.sendMessage('This image is too large. File size must be under 5MB.');
            return null;
        }
        if(file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif' ){
            this.props.sendMessage('File type not supported. Please use PNG, JPEG, or GIF file format.');
            return null
        }

        this.setState({ file: e.target.files[0].name, fileType: e.target.files[0].type});
		if (e.target.files && e.target.files.length > 0) {
			const reader = new FileReader();
			reader.addEventListener(
				'load',
				() =>{this.setState({
                    imageSrc: reader.result,
                    image: reader.result,
                    isGif: (file.type === 'image/gif'),
                    controlsOpen: true
                });
				(file.type === 'image/gif') ? this.getCroppedImg(this.state.file, true, file.type) : this.setState({isGif:false});
				},false
			);
			reader.readAsDataURL(e.target.files[0])
		}
	};
	setCanvas = canvas => {
		this.setState({ canvas: canvas });
	};
	onZoomChange = zoom => {
		this.setState({ zoom: zoom });
	};
	onPreview = () => {
		this.getCroppedImg(this.state.file, true, this.state.fileType);
	};
	onSubmit = () => {
		this.getCroppedImg(this.state.file,false, this.state.fileType);
	};
	onCancel = () => {
		this.setState({ imageSrc: null, image: null, zoom: 1, controlsOpen: false });
        this.props.previewImage(null);
	};
	//is used to toggle image window when logo selector is active
	toggleActiveSelection = () => {
		if (this.props.cta) {
			this.setState({
				canvas: null,
				image: null,
				imageSrc: null,
				zoom: 1,
				file: null
			});
		}
        this.props.previewImage(null);
	};
	render() {
		let { cta, imageSize, cropSize, zoomRange, isLogoCropper } = this.props;
		return (
			<div className={`imageupload active-${this.state.controlsOpen} ${this.props.classes.imageupload} uploadingimage-${this.props.uploadingCustomImage}`}>
				{!this.state.controlsOpen && (<Input
					onSelect={this.onSelectFile}
					cta={cta}
				/>)}
					{this.state.controlsOpen && (<div className={`cropperSlider`}><div className={'inner'}>
							{ this.state.isGif ? <Gif src={this.state.imageSrc} /> : <Cropper
							imageSize={imageSize}
							image={this.state.imageSrc}
							width={cropSize.width}
							height={cropSize.height}
							zoom={this.state.zoom}
							previewMethod={this.onPreview}
							setCanvas={this.setCanvas}
							toggleActiveSelection={this.toggleActiveSelection}
							cta={cta}
							isLogoCropper={isLogoCropper}
						/>}
						<Controls
							zoomRange={zoomRange}
							isGif={this.state.isGif}
							zoom={this.state.zoom}
							zoomChange={this.onZoomChange}
							submit={this.onSubmit}
							cancel={this.onCancel}
							onNewSelect={this.onSelectFile}
							loading={this.props.uploadingCustomImage}
						/>
					</div>
				</div>)}
			</div>
		);
	};
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageUpload);

